




export default function suCrypt(id) {
    return btoa(btoa(id));
}
